(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9792);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/base/seo.tsx
var seo = __webpack_require__(2857);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/hooks/use-mobile-detection.ts
var use_mobile_detection = __webpack_require__(3634);
// EXTERNAL MODULE: ./src/utils/static-import-icon.tsx + 10 modules
var static_import_icon = __webpack_require__(3353);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 4 modules
var Stack = __webpack_require__(7668);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 62 modules
var Tooltip = __webpack_require__(5203);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(6227);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(3795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(5551);
;// CONCATENATED MODULE: ./src/components/description/view.tsx





const SocialButton = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        gap: 3,
        className: "mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "social-button-stack",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: "Telegram",
                    placement: "top",
                    TransitionComponent: Fade/* default */.Z,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        "data-testid": "social-link-telegram",
                        href: "https://t.me/catsolhat1",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TELEGRAM */.u.TELEGRAM),
                            alt: static_import_icon/* IconName.TELEGRAM */.u.TELEGRAM,
                            width: 25
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "social-button-stack",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: "X",
                    placement: "top",
                    TransitionComponent: Fade/* default */.Z,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        "data-testid": "social-link-x",
                        href: "https://x.com/catsolhat",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.X */.u.X),
                            alt: static_import_icon/* IconName.X */.u.X,
                            width: 25
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "social-button-stack",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: "Youtube",
                    placement: "top",
                    TransitionComponent: Fade/* default */.Z,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        "data-testid": "social-link-youtube",
                        href: "https://www.youtube.com/@catsolhat",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.YOUTUBE */.u.YOUTUBE),
                            alt: static_import_icon/* IconName.YOUTUBE */.u.YOUTUBE,
                            width: 25
                        })
                    })
                })
            })
        ]
    });
};
const MobileView = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-white text-opacity-50 font-dm_mono uppercase text-sm",
                children: "Airdrop Criteria"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                "data-testid": "description-divider",
                className: "w-9/12 mt-2",
                style: {
                    height: "1px",
                    backgroundColor: "rgba(255, 255, 255, 0.16)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "w-9/12 text-center text-white mt-2 text-opacity-50 font-dm_mono uppercase text-sm",
                children: "Early Contributors, Active Wallets on Solana DEXs, Saga Phone Buyers, Top NFT Collections Holders,..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                "data-testid": "full-details-link",
                href: "https://catsolhat.medium.com/catsolhat-super-airdrop-8b7f8723617f",
                target: "_blank",
                rel: "noopener",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "text-white mt-2 font-medium font-dm_mono underline uppercase text-sm",
                    children: "Check out the full details here"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButton, {})
        ]
    });
};
const DesktopView = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-white text-opacity-50 font-dm_mono uppercase",
                children: "Airdrop Criteria"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                "data-testid": "description-divider",
                className: "w-9/12 mt-4",
                style: {
                    height: "1px",
                    backgroundColor: "rgba(255, 255, 255, 0.16)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "w-9/12 text-center text-white mt-4 text-opacity-50 font-dm_mono uppercase",
                children: "Early Contributors, Active Wallets on Solana DEXs, Saga Phone Buyers, Top NFT Collections Holders,..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                "data-testid": "full-details-link",
                href: "https://catsolhat.medium.com/catsolhat-super-airdrop-8b7f8723617f",
                target: "_blank",
                rel: "noopener",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "text-white mt-4 font-medium font-dm_mono underline uppercase",
                    children: "Check out the full details here"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButton, {})
        ]
    });
};
const Description = ()=>{
    const isMobile = (0,use_mobile_detection/* default */.Z)();
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileView, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopView, {});
};
/* harmony default export */ var view = (Description);

;// CONCATENATED MODULE: ./src/components/description/index.tsx


;// CONCATENATED MODULE: ./src/assets/cat.png
/* harmony default export */ var cat = ({"src":"/_next/static/media/cat.c0582aa9.png","height":360,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABBklEQVR42mMAAWNNfVt1Tc0cBwtDmQ1z28SSPWRYGGBA28G4QcfE4L+Kstp/PU3l+wu6Kk5OnbOKGyTX0dTKyOATXXnTIzD+v4QI488AZ7P/c+oS/i9vSfcEKVjZls7MkB4U+JKBQeE/kP+/LMDgz8qOtP/rJhV98mVgEGcAgWh/598pEW7/ugpD/8+uyfy/bFLrr/UL+v6vXzytFKygMtalZ/OUov8HVnT/3TCn6//iqR1/Ni+f9X/17O5DYAWzG1OilnTl/986r/X/xskl/3fPrf2/Y279n11Luv5vWz6lmGFmffzpnsKg/4vqI/9tm5r3/8Cimv+7F9T+3bF84v91i6fuAgBZe3Xll5T0SwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
;// CONCATENATED MODULE: ./src/components/description/thank-you.tsx




const CatThankyou = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        className: "absolute -bottom-1.5 left-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "absolute -top-16 -right-20 w-11/12 text-center text-white text-2xl font-dm_mono",
                    children: "Thanks for your contribution, folks!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: cat,
                    alt: "cat",
                    width: 340,
                    height: 340
                })
            ]
        })
    });
};
/* harmony default export */ var thank_you = (CatThankyou);

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./src/hooks/use-distributor-data.ts
var use_distributor_data = __webpack_require__(9419);
// EXTERNAL MODULE: ./src/providers/solana/index.tsx + 1 modules
var solana = __webpack_require__(3671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/@coral-xyz/anchor/dist/browser/index.js
var browser = __webpack_require__(9828);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(8456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/utils/apis/merkle-tree.ts
var merkle_tree = __webpack_require__(4725);
;// CONCATENATED MODULE: ./src/hooks/use-merkle-tree.ts


const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const useProof = (publicKey)=>{
    const LOCAL_STORAGE_KEY = "merkleProof_".concat(publicKey.toString());
    const fetchProof = async ()=>{
        const storedData = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (storedData) {
            const { proof , timestamp  } = JSON.parse(storedData);
            if (Date.now() - timestamp < CACHE_DURATION) {
                return proof;
            }
        }
        const proof1 = await (0,merkle_tree/* fetchMerkleProof */.G)(publicKey);
        const dataToStore = {
            proof: proof1,
            timestamp: Date.now()
        };
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(dataToStore));
        return proof1;
    };
    const { data: proofData , isLoading: isProofLoading , refetch: refetchProof  } = (0,es.useQuery)([
        "proof",
        publicKey
    ], fetchProof, {
        enabled: !!publicKey,
        staleTime: CACHE_DURATION
    });
    const { proof , index , amount  } = proofData !== null && proofData !== void 0 ? proofData : {
        proof: [],
        index: 0,
        amount: 0
    };
    return {
        data: {
            proof,
            index,
            amount
        },
        isLoading: isProofLoading,
        refetch: refetchProof
    };
};

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(7066);
;// CONCATENATED MODULE: ./src/utils/apis/claim.ts

async function updateClaimStatusApi(publicKey) {
    const response = await axios/* default.patch */.Z.patch("".concat("https://api.catsolhat.com/api/v1", "/users/claim"), {}, {
        params: {
            wallet_address: publicKey.toBase58(),
            token_symbol: "OIIA"
        }
    });
    return {
        walletAddress: response.data.wallet_address,
        amount: response.data.amount,
        isClaimed: response.data.is_claimed
    };
}

// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(3680);
;// CONCATENATED MODULE: ./src/components/claim/view.tsx
/* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];













const Claim = ()=>{
    const { data: distributorData , error , isLoading  } = (0,use_distributor_data/* useDistributorData */.X)();
    var _distributorData_startTs;
    const startDateTimestamp = Number((_distributorData_startTs = distributorData === null || distributorData === void 0 ? void 0 : distributorData.startTs) !== null && _distributorData_startTs !== void 0 ? _distributorData_startTs : 0);
    const isBeforeAirdropPeriod = startDateTimestamp > Date.now() / 1000;
    const startDate = moment_default()(startDateTimestamp * 1000).format("DD-MM-YYYY");
    const isMobile = (0,use_mobile_detection/* default */.Z)();
    const tokenSymbol = "OIIA";
    const isSolcat = tokenSymbol == "SOLCAT" || !tokenSymbol;
    const { connection , provider , program , ctx , distributorClient , mintPublicKey , merkleTreeVersion , distributor , publicKey , connected  } = (0,solana/* useSolana */.X)();
    if (!connection || !provider || !program || !ctx || !distributorClient || !mintPublicKey || !merkleTreeVersion || !distributor || !publicKey) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
    const { data: { proof , index , amount  } , isLoading: isProofLoading , refetch: refetchProof  } = useProof(publicKey);
    const { mutate: claim , isLoading: isClaiming  } = (0,es.useMutation)(async ()=>{
        const claimAmount = new browser.BN(amount);
        const proofBufferArray = proof.map((p)=>Buffer.from(p, "hex"));
        const tx = await distributorClient.newClaim(mintPublicKey, new browser.BN(index), claimAmount, proofBufferArray, new browser.BN(merkleTreeVersion));
        const signature = await tx.buildAndExecute();
        const latestBlockHash = await connection.getLatestBlockhash();
        await connection.confirmTransaction({
            blockhash: latestBlockHash.blockhash,
            lastValidBlockHeight: latestBlockHash.lastValidBlockHeight,
            signature: signature
        });
        await updateClaimStatusApi(publicKey);
    }, {
        onSuccess: ()=>{
            refetchClaimStatus();
        }
    });
    const { data: isClaimed , isLoading: isClaimInfoLoading , refetch: refetchClaimStatus  } = (0,es.useQuery)([
        "isClaimed",
        publicKey
    ], async ()=>{
        if (!publicKey) {
            throw new Error("Public key is null");
        }
        const claimStatusPDA = distributorClient.pda.claim_status(publicKey, distributor.key);
        const accountInfo = await connection.getAccountInfo(claimStatusPDA.key);
        if (!accountInfo) {
            return false;
        }
        const claimStatus = await distributorClient.ctx.program.account.claimStatus.fetch(claimStatusPDA.key);
        return claimStatus.isClaimed;
    }, {
        enabled: connected,
        staleTime: 1 * 60 * 1000
    });
    const MobileView = (param)=>/*#__PURE__*/ {
        let { tokenSymbol , isSolcat  } = param;
        return (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            className: "bg-purple-200 rounded-2xl flex-col mx-auto justify-evenly ".concat(isSolcat ? "h-[180px]" : "p-6"),
            gap: isSolcat ? 0 : 2,
            children: isProofLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                className: "mx-auto text-[#9945ff]"
            }) : proof.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "flex flex-col justify-evenly px-2",
                gap: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "uppercase text-[#0F0F0F] text-sm font-dm_mono",
                        children: "ahhh dang it"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "uppercase text-[#0F0F0F] text-xl font-cc text-center",
                        children: "you are not eligible"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        className: "flex flex-col justify-between items-center",
                        gap: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "uppercase text-[#0F0F0F] text-sm font-dm_mono text-center",
                                children: [
                                    "Congrats, You are Eligible!",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block",
                                        children: "Your allocation:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "uppercase text-[#0F0F0F] text-[20px] text-center font-cc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-rammetto",
                                        children: "".concat(amount / constants/* MICRO_TOKEN */.j)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-cc ml-1",
                                        children: tokenSymbol
                                    })
                                ]
                            })
                        ]
                    }),
                    distributorData && isBeforeAirdropPeriod ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: "text-[#0F0F0F] text-sm font-dm_mono text-center uppercase bg-[#DCC1FF] px-4 py-2 rounded-full mx-auto",
                        children: [
                            "Comeback on ",
                            startDate,
                            " to claim"
                        ]
                    }) : isClaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "px-6 py-3 bg-black/5 rounded-[100px] justify-center items-center gap-2.5 inline-flex text-xl font-normal uppercase font-cc mx-auto ",
                        disabled: true,
                        children: "Claimed"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "px-6 py-3 text-white bg-[#9945ff] rounded-[100px] justify-center items-center gap-2.5 inline-flex text-xl font-normal hover:bg-opacity-80 uppercase font-cc mx-auto ",
                        onClick: ()=>claim(),
                        disabled: isClaiming || isClaimInfoLoading,
                        children: isClaiming || isClaimInfoLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 24,
                            className: "text-white"
                        }) : "Claim Now"
                    })
                ]
            })
        });
    };
    const DesktopView = (param)=>/*#__PURE__*/ {
        let { tokenSymbol , isSolcat  } = param;
        return (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            className: "w-full max-w-[768px] bg-purple-200 ".concat(isSolcat ? "rounded-2xl" : "rounded-[40px]", " flex-col mx-auto justify-evenly  ").concat(isSolcat ? "h-[180px]" : "p-8"),
            gap: isSolcat ? 0 : 4,
            children: isProofLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                className: "mx-auto text-[#9945ff]"
            }) : proof.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "flex flex-col justify-evenly",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "uppercase text-[#0F0F0F] text-[20px] font-dm_mono text-center",
                        children: "ahhh dang it"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "uppercase text-[#0F0F0F] text-[32px] font-cc text-center",
                        children: "you are not eligible"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        className: "flex flex-col justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "text-[#0F0F0F] text-[20px] ".concat(isSolcat ? "font-dm_mono" : "font-dm_mono_regular", " text-center"),
                                children: [
                                    "Congrats, You are Eligible! ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Your allocation:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "uppercase text-[#0F0F0F] text-[32px] text-center font-cc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-rammetto",
                                        children: "".concat(amount / constants/* MICRO_TOKEN */.j)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-cc ml-1",
                                        children: tokenSymbol
                                    })
                                ]
                            })
                        ]
                    }),
                    distributorData && isBeforeAirdropPeriod ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: "text-[#0F0F0F] text-xl font-dm_mono text-center uppercase bg-[#DCC1FF] px-4 py-2 rounded-full mx-auto",
                        children: [
                            "Comeback on ",
                            startDate,
                            " to claim"
                        ]
                    }) : isClaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "px-6 py-3 bg-black/5 rounded-[100px] justify-center items-center gap-2.5 inline-flex text-xl font-normal uppercase font-cc mx-auto ",
                        disabled: true,
                        children: "Claimed"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "px-6 py-3 text-white bg-[#9945ff] rounded-[100px] justify-center items-center gap-2.5 inline-flex text-xl font-normal hover:bg-opacity-80 uppercase font-cc mx-auto ",
                        onClick: ()=>claim(),
                        disabled: isClaiming || isClaimInfoLoading,
                        children: isClaiming || isClaimInfoLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 24,
                            className: "text-white"
                        }) : "Claim Now"
                    })
                ]
            })
        });
    };
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileView, {
            tokenSymbol: "".concat((0,helpers/* isSolcatToken */.k)(tokenSymbol) ? "solcat" : tokenSymbol),
            isSolcat: isSolcat
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopView, {
        tokenSymbol: "".concat((0,helpers/* isSolcatToken */.k)(tokenSymbol) ? "solcat" : tokenSymbol),
        isSolcat: isSolcat
    });
};
/* harmony default export */ var claim_view = (Claim);

;// CONCATENATED MODULE: ./src/components/claim/index.tsx


// EXTERNAL MODULE: ./src/components/connect-wallet/index.ts + 2 modules
var connect_wallet = __webpack_require__(7131);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(8130);
;// CONCATENATED MODULE: ./src/components/count-down-content/count-down.tsx
"use client";




const Item = (param)=>{
    let { time , label  } = param;
    const isMobile = (0,use_mobile_detection/* default */.Z)();
    const textSize = isMobile ? "text-sm" : "text-[32px] leading-10";
    const tokenSymbol = "OIIA";
    const isSolCatToken = tokenSymbol == "SOLCAT" || !tokenSymbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            className: "text-white ".concat(textSize, " ").concat(isSolCatToken ? "font-dm_mono" : "font-dm_mono_regular", " "),
            children: "".concat((0,index_es/* zeroPad */.Bu)(time)).concat(label)
        })
    });
};
function CountDown(props) {
    const { date  } = props;
    const isMobile = (0,use_mobile_detection/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
        date: date,
        renderer: (param)=>/*#__PURE__*/ {
            let { days , hours , minutes , seconds  } = param;
            return (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                gap: isMobile ? 1 : 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: days,
                        label: "d"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: hours,
                        label: "h"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: minutes,
                        label: "m"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: seconds,
                        label: "s"
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var count_down = (CountDown);

;// CONCATENATED MODULE: ./src/components/count-down-content/mobile.tsx




const DuringAirDrop = (isSolCatToken, endTs)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSolCatToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                children: "claim airdrop"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "pt-8",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                        children: "claim your"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                        children: "solcat airdrop"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                className: "pt-3 pb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-white text-sm ".concat(isSolCatToken ? "font-dm_mono" : "font-dm_mono_regular"),
                        children: "Remaining time:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(count_down, {
                        date: new Date(endTs * 1000)
                    })
                ]
            })
        ]
    });
};
const BeforeAirDrop = (isSolCatToken, startDate)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSolCatToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                children: "claim airdrop"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "pt-8",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                        children: "check your"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                        children: "airdrop Amount"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "column",
                className: "pt-3 pb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        className: "justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "text-white text-sm font-dm_mono uppercase",
                            children: "Airdrop start on ".concat(moment_default()(startDate).format("LL"))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        className: "justify-center",
                        gap: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-white text-sm font-dm_mono uppercase",
                                children: "Remaining time:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(count_down, {
                                date: new Date(startDate.getTime())
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const AfterAirdrop = (isSolCatToken)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSolCatToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                children: "claim airdrop"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "pt-8",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                        children: "claim your"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-2xl font-normal font-cc uppercase",
                        children: "solcat airdrop"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                className: "pt-3 pb-5",
                gap: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "text-white text-md font-dm_mono uppercase",
                    children: "Airdrop ended, thank you!"
                })
            })
        ]
    });
};
const mobileView = (isSolCatToken, airdropTime)=>{
    const { startTs , endTs  } = airdropTime;
    const currentTime = new Date();
    if (currentTime.getTime() < startTs * 1000) {
        return BeforeAirDrop(isSolCatToken, new Date(startTs * 1000));
    }
    if (currentTime.getTime() < endTs * 1000) {
        return DuringAirDrop(isSolCatToken, endTs);
    }
    return AfterAirdrop(isSolCatToken);
};
/* harmony default export */ var mobile = (mobileView);

;// CONCATENATED MODULE: ./src/components/count-down-content/view.tsx








const view_DuringAirDrop = (isSolCatToken, endTs)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSolCatToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-center text-teal-300 text-[32px] leading-10 font-normal font-cc uppercase",
                children: "claim airdrop"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "pt-8",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-5xl font-normal font-cc uppercase",
                        children: "claim your"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-5xl font-normal font-cc uppercase",
                        children: "solcat airdrop"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                className: "pt-6 pb-12",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-white text-[32px] leading-10 ".concat(isSolCatToken ? "font-dm_mono" : "font-dm_mono_regular"),
                        children: "Remaining time:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(count_down, {
                        date: new Date(endTs * 1000)
                    })
                ]
            })
        ]
    });
};
const view_BeforeAirDrop = (isSolCatToken, startDate)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSolCatToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-center text-teal-300 text-[32px] leading-10 font-normal font-cc uppercase",
                children: "claim airdrop"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "pt-8",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-5xl font-normal font-cc uppercase",
                        children: "check your"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-5xl font-normal font-cc uppercase",
                        children: "airdrop Amount"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "column",
                className: "pt-6 pb-12",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        className: "w-full justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "text-white text-[32px] font-dm_mono uppercase",
                            children: "Airdrop start on ".concat(moment_default()(startDate).format("LL"))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        gap: 2,
                        className: "w-full justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-white text-[32px] leading-10 font-dm_mono uppercase",
                                children: "Remaining time:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(count_down, {
                                date: new Date(startDate.getTime())
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const view_AfterAirdrop = (isSolCatToken)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSolCatToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-center text-teal-300 text-5xl font-normal font-cc uppercase",
                children: "claim airdrop"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "pt-8",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-5xl font-normal font-cc uppercase",
                        children: "claim your"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-center text-teal-300 text-5xl font-normal font-cc uppercase",
                        children: "solcat airdrop"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                className: "pt-6 pb-12",
                gap: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "text-white text-3xl font-dm_mono uppercase",
                    children: "Airdrop ended, thank you!"
                })
            })
        ]
    });
};
const Content = (isSolCatToken, airdropTime)=>{
    const { startTs , endTs  } = airdropTime;
    const currentTime = new Date();
    if (currentTime.getTime() < startTs * 1000) {
        return view_BeforeAirDrop(isSolCatToken, new Date(startTs * 1000));
    }
    if (currentTime.getTime() > endTs * 1000) {
        return view_AfterAirdrop(isSolCatToken);
    }
    return view_DuringAirDrop(isSolCatToken, endTs);
};
const CountDownContent = ()=>{
    const isMobile = (0,use_mobile_detection/* default */.Z)();
    const { data: distributorData  } = (0,use_distributor_data/* useDistributorData */.X)();
    const tokenSymbol = "OIIA";
    const isSolCatToken = tokenSymbol == "SOLCAT" || !tokenSymbol;
    if (!distributorData) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        alignItems: "center",
        "data-testid": "count-down",
        className: "".concat(isSolCatToken ? "" : isMobile ? "pt-3" : "pt-6"),
        children: isMobile ? mobile(isSolCatToken, distributorData) : Content(isSolCatToken, distributorData)
    });
};
/* harmony default export */ var count_down_content_view = (CountDownContent);

;// CONCATENATED MODULE: ./src/components/count-down-content/index.tsx


// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(1730);
// EXTERNAL MODULE: ./src/hooks/use-trans.ts + 1 modules
var use_trans = __webpack_require__(942);
// EXTERNAL MODULE: ./src/utils/apis/project-details.ts
var project_details = __webpack_require__(7127);
;// CONCATENATED MODULE: ./src/components/project-details/view.tsx








const view_SocialButton = ()=>{
    var _trans_tokenSymbol, _trans_tokenSymbol1, _trans_tokenSymbol2;
    const trans = (0,use_trans/* default */.Z)();
    const tokenSymbol = "OIIA";
    if (!tokenSymbol) {
        throw new Error("Token symbol is not set");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        gap: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "social-button-stack",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: "Web",
                    placement: "top",
                    TransitionComponent: Fade/* default */.Z,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        "data-testid": "social-link-web",
                        href: (_trans_tokenSymbol = trans[tokenSymbol]) === null || _trans_tokenSymbol === void 0 ? void 0 : _trans_tokenSymbol.website_url,
                        target: "_blank",
                        rel: "noreferrer",
                        height: 40,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.WEB */.u.WEB),
                            alt: static_import_icon/* IconName.WEB */.u.WEB,
                            width: 40,
                            height: 40
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "social-button-stack",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: "Telegram",
                    placement: "top",
                    TransitionComponent: Fade/* default */.Z,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        "data-testid": "social-link-telegram",
                        href: (_trans_tokenSymbol1 = trans[tokenSymbol]) === null || _trans_tokenSymbol1 === void 0 ? void 0 : _trans_tokenSymbol1.telegram_url,
                        target: "_blank",
                        rel: "noreferrer",
                        height: 40,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.TELEGRAM */.u.TELEGRAM),
                            alt: static_import_icon/* IconName.TELEGRAM */.u.TELEGRAM,
                            width: 40,
                            height: 40
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                className: "social-button-stack",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: "X",
                    placement: "top",
                    TransitionComponent: Fade/* default */.Z,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        "data-testid": "social-link-x",
                        href: (_trans_tokenSymbol2 = trans[tokenSymbol]) === null || _trans_tokenSymbol2 === void 0 ? void 0 : _trans_tokenSymbol2.x_url,
                        target: "_blank",
                        rel: "noreferrer",
                        height: 40,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,static_import_icon/* staticImportIcon */.N)(static_import_icon/* IconName.X */.u.X),
                            alt: static_import_icon/* IconName.X */.u.X,
                            width: 40,
                            height: 40
                        })
                    })
                })
            })
        ]
    });
};
const ProjectHeader = ()=>{
    var _trans_tokenSymbol, _trans_tokenSymbol1;
    const trans = (0,use_trans/* default */.Z)();
    const isLg = (0,useMediaQuery/* default */.Z)("(min-width:1200px)");
    const isMd = (0,useMediaQuery/* default */.Z)("(min-width:810px)");
    const tokenSymbol = "OIIA" || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                lg: 6,
                container: true,
                className: isLg ? "" : "flex justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/logos/".concat(tokenSymbol, ".png"),
                        alt: tokenSymbol,
                        width: 72,
                        height: 72,
                        className: "rounded-full ".concat(isLg ? "mr-8" : isMd ? "mb-8" : "mb-4")
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        lg: 4,
                        className: "".concat(isLg ? "" : isMd ? "mb-8" : "mb-4"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "".concat(isLg ? "" : "flex justify-center", " text-white font-dm_mono ").concat(isMd ? "text-[20px]" : "text-[14px]"),
                                children: (_trans_tokenSymbol = trans[tokenSymbol]) === null || _trans_tokenSymbol === void 0 ? void 0 : _trans_tokenSymbol.token_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "".concat(isLg ? "" : "flex justify-center", " text-white font-cc uppercase ").concat(isMd ? "text-[32px]" : "text-[20px]"),
                                children: "OIIA"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                lg: 6,
                container: true,
                justifyContent: isLg ? "flex-end" : "center",
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: isLg ? "mr-8" : "w-full flex justify-center ".concat(isMd ? "mb-8" : "mb-4"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(view_SocialButton, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        component: "a",
                        href: (_trans_tokenSymbol1 = trans[tokenSymbol]) === null || _trans_tokenSymbol1 === void 0 ? void 0 : _trans_tokenSymbol1.guide_url,
                        target: "_blank",
                        rel: "noreferrer",
                        "data-testid": "social-link-guide",
                        className: "rounded-full px-6 py-3 leading-6 h-12 text-[#6dfcd1] bg-[rgba(255,255,255,0.16)] hover:bg-[rgba(109,252,209)] hover:text-black",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "font-normal font-cc uppercase text-sm md:text-base",
                            children: "Guide"
                        })
                    })
                ]
            })
        ]
    });
};
const ProjectDetails = ()=>{
    var _trans_tokenSymbol, _trans_tokenSymbol1, _trans_tokenSymbol2, _trans_tokenSymbol3;
    const trans = (0,use_trans/* default */.Z)();
    const tokenSymbol = "OIIA";
    if (!tokenSymbol) {
        throw new Error("Token symbol is not set");
    }
    const isMd = (0,useMediaQuery/* default */.Z)("(min-width:810px)");
    const isMobile = (0,use_mobile_detection/* default */.Z)();
    const { data: projectDetailsApiData , isLoading: projectDetailsLoading , isError: projectDetailsError , refetch: projectDetailsRefetch  } = (0,es.useQuery)("projectDetails", project_details/* fetchProjectDetails */.G);
    function formatDateTime(dateStr) {
        const date = new Date(dateStr);
        // Convert to UTC time
        const options = {
            hour: "numeric",
            hour12: true,
            timeZone: "UTC"
        };
        const utcTime = date.toLocaleString("en-US", options);
        const day = date.getUTCDate();
        const month = date.toLocaleString("en-US", {
            month: "long",
            timeZone: "UTC"
        });
        return "".concat(utcTime, " UTC, ").concat(month, " ").concat(day);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        gap: {
            xs: 3,
            md: 6
        },
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    borderColor: "rgba(255, 255, 255, 0.08)",
                    borderBottomWidth: "2px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        lg: 6,
                        className: "pr-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "".concat(isMobile ? "text-[14px]" : "text-[20px]", " text-white font-normal font-cc uppercase mb-5"),
                                children: "About"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: "".concat(isMobile ? "text-[14px]" : "text-base", " text-white font-normal font-dm_mono_regular mb-12"),
                                dangerouslySetInnerHTML: {
                                    __html: (_trans_tokenSymbol = trans[tokenSymbol]) === null || _trans_tokenSymbol === void 0 ? void 0 : _trans_tokenSymbol.description
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "".concat(isMobile ? "text-[14px]" : "text-[20px]", " text-white font-normal font-cc uppercase mb-5"),
                                children: "Eligibility"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: "".concat(isMobile ? "text-[14px]" : "text-[16px]", " text-white font-normal font-dm_mono_regular mb-5"),
                                dangerouslySetInnerHTML: {
                                    __html: (_trans_tokenSymbol1 = trans[tokenSymbol]) === null || _trans_tokenSymbol1 === void 0 ? void 0 : _trans_tokenSymbol1.eligibility(new Intl.NumberFormat("en-US").format((projectDetailsApiData === null || projectDetailsApiData === void 0 ? void 0 : projectDetailsApiData.eligibleAmount) || 0))
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "column",
                                gap: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        className: "w-fit",
                                        href: "https://jup.ag/swap/SOL-SOLCAT",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "font-dm_mono_regular underline text-[#6dfcd1]",
                                            children: "Buy SOLCAT here"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        className: "w-fit",
                                        href: "https://v2-staking.catsolhat.com/",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "font-dm_mono_regular underline text-[#6dfcd1]",
                                            children: "Stake SOLCAT here"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        lg: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "".concat(isMobile ? "text-[14px]" : "text-[20px] leading-7", " text-white font-normal font-cc uppercase mb-5"),
                                children: "Token metrics"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: {
                                    xs: 1,
                                    md: 2
                                },
                                justifyContent: "space-between",
                                className: "py-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular text-opacity-50"),
                                            children: "Token Name"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular w-auto"),
                                            align: isMd ? "right" : "left",
                                            children: (_trans_tokenSymbol2 = trans[tokenSymbol]) === null || _trans_tokenSymbol2 === void 0 ? void 0 : _trans_tokenSymbol2.token_name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    borderColor: "rgba(255, 255, 255, 0.08)",
                                    borderBottomWidth: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: {
                                    xs: 1,
                                    md: 2
                                },
                                justifyContent: "space-between",
                                className: "py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular text-opacity-50"),
                                            children: "Token Symbol"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular"),
                                            align: isMd ? "right" : "left",
                                            children: "OIIA"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    borderColor: "rgba(255, 255, 255, 0.08)",
                                    borderBottomWidth: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: {
                                    xs: 1,
                                    md: 2
                                },
                                justifyContent: "space-between",
                                className: "py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular text-opacity-50"),
                                            children: "Blockchain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular"),
                                            align: isMd ? "right" : "left",
                                            children: (_trans_tokenSymbol3 = trans[tokenSymbol]) === null || _trans_tokenSymbol3 === void 0 ? void 0 : _trans_tokenSymbol3.blockchain
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    borderColor: "rgba(255, 255, 255, 0.08)",
                                    borderBottomWidth: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: {
                                    xs: 1,
                                    md: 2
                                },
                                justifyContent: "space-between",
                                className: "py-3",
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular text-opacity-50"),
                                            children: "CA"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 11,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " break-words text-white font-dm_mono_regular"),
                                            align: isMd ? "right" : "left",
                                            children:  true ? "DU16Ea8MidPg8GcDYhCBx88THwYXSDiAXDnGA7xfe1HA" : 0
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    borderColor: "rgba(255, 255, 255, 0.08)",
                                    borderBottomWidth: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: {
                                    xs: 1,
                                    md: 2
                                },
                                justifyContent: "space-between",
                                className: "py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular text-opacity-50"),
                                            children: "TGE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular"),
                                            align: isMd ? "right" : "left",
                                            children: (projectDetailsApiData === null || projectDetailsApiData === void 0 ? void 0 : projectDetailsApiData.tge) ? formatDateTime(projectDetailsApiData === null || projectDetailsApiData === void 0 ? void 0 : projectDetailsApiData.tge) : "TBA"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    borderColor: "rgba(255, 255, 255, 0.08)",
                                    borderBottomWidth: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: {
                                    xs: 1,
                                    md: 2
                                },
                                justifyContent: "space-between",
                                className: "py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular text-opacity-50"),
                                            children: "Total Supply"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 8,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular"),
                                            align: isMd ? "right" : "left",
                                            children: [
                                                new Intl.NumberFormat("en-US").format((projectDetailsApiData === null || projectDetailsApiData === void 0 ? void 0 : projectDetailsApiData.totalSupply) || 0),
                                                " ",
                                                "OIIA"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    borderColor: "rgba(255, 255, 255, 0.08)",
                                    borderBottomWidth: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: {
                                    xs: 1,
                                    md: 2
                                },
                                justifyContent: "space-between",
                                className: "py-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular text-opacity-50"),
                                            children: "Airdrop Allocation"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        md: 8,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            className: "".concat(isMobile ? "text-[12px]" : "text-[18px] leading-[26px]", " text-white font-dm_mono_regular"),
                                            align: isMd ? "right" : "left",
                                            children: [
                                                new Intl.NumberFormat("en-US").format((projectDetailsApiData === null || projectDetailsApiData === void 0 ? void 0 : projectDetailsApiData.airdropAllocation) || 0),
                                                " ",
                                                "OIIA"
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    borderColor: "rgba(255, 255, 255, 0.08)",
                    borderBottomWidth: "2px"
                },
                className: "mb-6 md:mb-12"
            })
        ]
    });
};
/* harmony default export */ var project_details_view = (ProjectDetails);

;// CONCATENATED MODULE: ./src/components/project-details/index.tsx


;// CONCATENATED MODULE: ./src/components/home/view.tsx













const Home = ()=>{
    const isMobile = (0,use_mobile_detection/* default */.Z)();
    const { connected  } = (0,solana/* useSolana */.X)();
    const { data: distributorData  } = (0,use_distributor_data/* useDistributorData */.X)();
    var _distributorData_endTs;
    const isAirdropEnded = ((_distributorData_endTs = distributorData === null || distributorData === void 0 ? void 0 : distributorData.endTs) !== null && _distributorData_endTs !== void 0 ? _distributorData_endTs : 0) < Date.now() / 1000;
    const showCat = !isMobile && isAirdropEnded;
    const [windowWidth, setWindowWidth] = (0,react.useState)(0);
    const tokenSymbol = "OIIA";
    const isSolCatToken = tokenSymbol == "SOLCAT" || !tokenSymbol;
    let classStyle = isMobile ? isSolCatToken ? "h-[calc(100vh_-100px)] rounded-[20px] px-6 " : "rounded-[20px] px-6 pt-8 pb-14 " : isSolCatToken ? "h-[calc(100vh_-135px)] rounded-[40px] px-10 pt-6 pb-6 " : "rounded-[40px] px-16 pt-12 pb-28 ";
    (0,react.useEffect)(()=>{
        setWindowWidth(window.innerWidth);
    }, []);
    classStyle += isSolCatToken ? "bg-gradient-page" : "bg-gradient-page-2";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSolCatToken && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/banners/".concat(tokenSymbol, ".png"),
                width: 790,
                alt: tokenSymbol,
                sizes: "100vw",
                height: 263.33,
                className: "".concat(isMobile ? "rounded-[20px]" : "rounded-[32px]"),
                layout: "responsive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "".concat(isMobile ? "mt-2 rounded-[20px]" : "mt-1 rounded-[40px]", " relative ").concat(windowWidth <= 1200 ? "" : "border-2 border-teal-300 border-solid ", " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        className: "".concat(classStyle),
                        children: [
                            !isSolCatToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(project_details_view, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(count_down_content_view, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                className: "w-full px-6 ".concat(isSolCatToken ? "" : "pb-3 md:pb-6", " "),
                                children: [
                                    !isAirdropEnded && !connected && /*#__PURE__*/ (0,jsx_runtime.jsx)(connect_wallet/* default */.Z, {}),
                                    !isAirdropEnded && connected && /*#__PURE__*/ (0,jsx_runtime.jsx)(claim_view, {})
                                ]
                            }),
                            isSolCatToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                className: "mt-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(view, {})
                            })
                        ]
                    }),
                    isSolCatToken && showCat && /*#__PURE__*/ (0,jsx_runtime.jsx)(thank_you, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var home_view = (Home);

;// CONCATENATED MODULE: ./src/components/home/index.tsx


// EXTERNAL MODULE: ./src/layouts/main-layout/index.tsx + 4 modules
var main_layout = __webpack_require__(9408);
;// CONCATENATED MODULE: ./src/pages/index.tsx
/* provided dependency */ var process = __webpack_require__(4155);





const Index = ()=>{
    const trans = (0,use_trans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            process.env.NEXT_PUBLIC_ENABLE_SEO === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                data: {
                    title: trans.meta.title,
                    description: trans.meta.description,
                    thumbnailUrl: trans.meta.thumbnail_url,
                    url: "".concat(process.env.NEXT_PUBLIC_SITE_URL)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(main_layout/* MainLayout */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home_view, {})
            })
        ]
    });
};
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,77,600,90,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);